import React, { useState, useEffect } from 'react';

import ScanSamplesDisplay from './ScanSamplesDisplay';
import { MessageModal } from '../../MessageModal';
import { ConfirmationModal } from '../../confirmationModalComp';

import 'bootstrap/dist/css/bootstrap.min.css'
import '../../../styles.css'

import Alert from 'react-bootstrap/Alert';

import { useCookies } from 'react-cookie';

function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).padStart(4, '0');

    return `${year}-${month}-${day}`;
}

// set at build time via the REACT_APP_EXPRESS_URL build arg; falls back to the prod service
const fetchURI = process.env.REACT_APP_EXPRESS_URL
const scannedReceivedSamplesEndpoint = `${fetchURI}saveReceivedSampleCodes`;

const ScanLabNumbers = (props) => {
    const { globalVs, labs, sampleTypes } = props;
    const currentDate = new Date();
    const formattedDate = formatDate(currentDate);

    const [packageCode, setPackageCode] = useState("");
    const [packageCodesArray, setPackageCodesArray] = useState([]);
    const [sampleType, setSampleType] = useState({
        "SampleType_ID": "",
        "SampleType_VC": ""
    });
    const [lab, setLab] = useState({
        "Lab_ID": "",
        "Lab_VC": ""
    });
    // const [dateReceived, setDateReceived] = useState(formattedDate);
    // console.log(dateReceived);

    const [cookies, setCookie] = useCookies(['user']);

    const [readyToSubmit, setReadyToAddToArray] = useState(false);

    const [showSuccess, setShowSuccess] = useState(false);
    const [showFail, setShowFail] = useState(false);
    const displayMessage = "This package is already in the list."
    const [showMessageModal, setShowMessageModal] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [showPackageCodeConfirmModal, setShowPackageCodeConfirmModal] = useState(false)

    const handleCookie = () => {
        setCookie('sampleType', sampleType, { path: '/' });
    }

    const handleSetReadyToAddToArray = () => { setReadyToAddToArray(true) }


    const handleUpdateScanSamples = (e) => {
        e.preventDefault();
        const value = e.target.value;
        switch (e.target.id) {
            case "prefPackageCode":
                setPackageCode(value)
                break;
            case "prefSampleType":
                const st = sampleTypes.find(x => x.SampleType_VC === value)
                setSampleType(st)
                break;
            case "prefLab":
                const lb = labs.find(x => x.Lab_VC === value)
                setLab(lb)
                break;
            // case "prefDateReceived":
            //     setDateReceived(value)
            //     break;
            default:
                break;
        }
    }

    const handleConfirmPackageCode = () => {
        setPackageCodesArray(prevArray => {
            if (!prevArray.includes(packageCode)) {
                return [...prevArray, packageCode]
            } else {
                setShowMessageModal(true)
                setTimeout(() => {
                    setShowMessageModal(false)
                }, 1500)
                return prevArray;
            }
        });
        setPackageCode("")
        setReadyToAddToArray(false)
        setShowPackageCodeConfirmModal(false)
    }

    const handleCancelPackageCode = () => {
        setPackageCode("")
        setReadyToAddToArray(false)
        setShowPackageCodeConfirmModal(false)
    }

    const handleSubmitSampleScan = async (e) => {
        if (submitting) {
            console.log("Already submitting.")
            return;
        }
        handleCookie()
        setSubmitting(true)
        // console.log('Scan Succesful');
        // console.log('packageCodes: ', packageCodesArray);
        // console.log('sampleType: ', sampleType);
        // console.log('lab: ', lab);
        // console.log('date: ', formattedDate);
        try {
            const scannedSampleFetch = await fetch(scannedReceivedSamplesEndpoint, {
                method: 'POST', body: JSON.stringify({
                    receivedSampleCodes: packageCodesArray,
                    datePackagesScanned: formattedDate,
                    packagesSampleType: sampleType.SampleType_ID,
                    packagesLab: lab.Lab_ID,
                    userScanning: globalVs.AdminUser_ID
                }), headers: { 'Content-Type': 'application/json' }
            });
            const scannedSampleTxt = await scannedSampleFetch.text();
            // console.log(scannedSampleTxt);
            if (scannedSampleTxt === "Received Sample Codes Saved Successfully") {
                setShowSuccess(true)
                handleCancelScan(e)
                setTimeout(() => {
                    setShowSuccess(false)
                }, 1000)
            } else {
                setShowFail(true)
                setTimeout(() => {
                    setShowFail(false)
                }, 4000)
            }

        } catch (error) {
            setShowFail(true)
            setTimeout(() => {
                setShowFail(false)
            }, 4000)
        } finally {
            setSubmitting(false)
        }
    }

    const handleRemoveScan = item => {
        setPackageCodesArray([...packageCodesArray.filter(el => el !== item)])
    }

    const handleCancelScan = (e) => {
        e.preventDefault();
        setPackageCodesArray([])
        setPackageCode("")
        setReadyToAddToArray(false)
    }

    useEffect(() => {
        let labOs = labs;
        const userDefaultLabId = globalVs.DefaultLab_ID;
        const defaultLabOption = labOs.find(dlab => dlab.Lab_ID === userDefaultLabId);
        setLab(defaultLabOption)
    }, [labs, globalVs, sampleType])

    useEffect(() => {
        //timer can fire while the input is empty (stray keypress, scanner suffix)
        //reset so the first character of the next scan isn't added on its own
        if (readyToSubmit && packageCode === "") {
            setReadyToAddToArray(false)
            return;
        }
        if (readyToSubmit && packageCode !== "") {
            //&& sampleType.SampleType_ID !== "" && lab.Lab_ID !== ""
            if (packageCode.includes('~') && packageCode.length < 50) {
                setShowPackageCodeConfirmModal(true)
                return;
            }
            if (packageCodesArray.length === 0) {
                setPackageCodesArray([packageCode])
            } else {
                //following adds anything to the array
                // setPackageCodesArray(prevArray => [...prevArray, packageCode]);

                //code below only adds unique codes to the array
                //and if a dup is attempted will display a modal that lets the user know it's already in the list
                setPackageCodesArray(prevArray => {
                    if (!prevArray.includes(packageCode)) {
                        return [...prevArray, packageCode]
                    } else {
                        setShowMessageModal(true)
                        setTimeout(() => {
                            setShowMessageModal(false)
                        }, 1500)
                        return prevArray;
                    }
                });
            }
            setPackageCode("")
            setReadyToAddToArray(false)
        }
        // eslint-disable-next-line
    }, [readyToSubmit, packageCode, sampleType, lab])

    useEffect(() => {
        if (cookies.sampleType) {
            setSampleType(cookies.sampleType);
        }
        // eslint-disable-next-line 
    }, [])

    return (
        <>
            {showSuccess &&
                <Alert key='success' variant='success' style={{ "marginTop": "-32px", marginBottom: "0px", height: "15px" }}>
                    <span style={{ "display": "flex", justifyContent: "center", "alignItems": "center", marginTop: "-15px" }}>Scanned Samples Successfully!</span>
                </Alert>
            }
            {showFail &&
                <Alert key='danger' variant='danger' style={{ "marginTop": "-32px", marginBottom: "0px", height: "15px" }}>
                    <span style={{ "display": "flex", justifyContent: "center", "alignItems": "center", marginTop: "-15px" }}>Something went wrong. Try again or contact IT</span>
                </Alert>
            }
            {showPackageCodeConfirmModal &&
                <ConfirmationModal
                    isOpen={showPackageCodeConfirmModal}
                    handleCloseModal={handleCancelPackageCode}
                    handleSubmit={handleConfirmPackageCode}
                    title={'Confirm Package Code'}
                    message={['The current package code may have been truncated. Either cancel and rescan or accept the scan if you believe it to be correct.', packageCode]}
                    submitButtonLabel={'Accept Scan'}
                />
            }
            <ScanSamplesDisplay
                packageCode={packageCode}
                sampleType={sampleType}
                lab={lab}
                // dateReceived={dateReceived}
                handleUpdateScanSamples={handleUpdateScanSamples}
                labOs={labs}
                sampleTypeOs={sampleTypes}
                handleSetReadyToAddToArray={handleSetReadyToAddToArray}
                handleSubmitSampleScan={handleSubmitSampleScan}
                submitting={submitting}
                handleCancelScan={handleCancelScan}
                packageCodesArray={packageCodesArray}
                handleRemoveScan={handleRemoveScan}
            />
            <MessageModal
                isOpen={showMessageModal}
                setShowEmailModal={setShowMessageModal}
                displayMessage={displayMessage}
            />
        </>
    )
}
export default ScanLabNumbers;